// src/data/events.js
// Single source of truth for gigs

export const upcomingEventsData = [
  { date: "24.09.2025", link: "https://www.instagram.com/p/DObWR8HDCNl", city: "Fribourg", name: "Centre Fries" },
  { date: "25.09.2025", link: "https://www.instagram.com/festival_de_sevelin/", city: "Lausanne", name: "Festival de Sévelin" },
  { date: "18.10.2025", link: "https://www.instagram.com/lesovversive/", city: "Lugano", name: "Le Sovversive" },
  { date: "08.08.2026", link: "https://www.kraftfeld.ch/de/programm/1770/node-amygdala-zuerich-sven-busato-winti-i-date-models-fribourg.html", city: "Winterthur", name: "KRAFTFELD" },
];

// — helpers —
function parseCH(dmy) {
  // "DD.MM.YYYY" → Date (local)
  const [d, m, y] = dmy.split(".").map(Number);
  return new Date(y, m - 1, d);
}
function startOfToday() {
  const t = new Date();
  t.setHours(0, 0, 0, 0);
  return t;
}

export function getUpcoming(now = new Date()) {
  const today = startOfToday();
  return upcomingEventsData
    .map(e => ({ ...e, _date: parseCH(e.date) }))
    .filter(e => e._date >= today)
    .sort((a, b) => a._date - b._date);
}

export function countUpcoming(now = new Date()) {
  return getUpcoming(now).length;
}
